export const selectPrecinct = state => state.precinct
